export function GetTranslatedValue(languageID, translationID, translationStore, translationValueStore, defaultValue){
    //console.log('[GetTranslatedValue] started. TranslationID: ' + translationID);
    
    let result = '';

    if(defaultValue){
        result = defaultValue;
    }

    if(translationID){
        let translation = translationStore.find((t) => { return t.ID === translationID });
        let translationValue = translationValueStore.find((tv) => { return tv.TranslationID === translationID && tv.LanguageID === languageID });

        if (translationValue && translationValue.Value){
            result = translationValue.Value;
        }
        else if (translation.DefaultValue){
            result = translation.DefaultValue;
        }
    }

    return result;
}